module.exports = __webpack_public_path__ + "39178800089351202fb867ec573b6aee.svg";